import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import { azureConnectSourceFlow } from './azureConnectSourceFlow';

import type { AzureSourceAccountState } from '../connectAzureSourceAccount';

export function AzureConnectSourceWizard({
  recalculateAccounts,
  sourceConnectScope,
}: {
  recalculateAccounts: () => void;
  sourceConnectScope: 'managementGroup' | 'subscription';
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async () => {
    recalculateAccounts();
    return true;
  };

  return (
    <Wizard<AzureSourceAccountState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[azureConnectSourceFlow]}
      title={`Connect source ${sourceConnectScope === 'managementGroup' ? 'management group' : 'subscription'}`}
      initialState={{
        onboardingFlow: false,
        tenantId: '',
        sourceConnectScope,
        enableScopeSelection: false,
        sourceConnectMethod: 'terraform',
        sourceSubscriptionId: '',
        sourceManagementGroupId: '',
      }}
    />
  );
}
